if(!customElements.get('product-main')) {
    class ProductMain extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
        this.variantsElement = this.querySelector('product-variants');
        this.quantityElement = this.querySelector('.quantity-input');
        if (this.quantityElement) {
          this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
        }
      }
  
      getCurrentVariant() {
        return this.variantsElement.getCurrentVariant();
      }
      getQuantity() {
        return this.quantityElement ? this.quantityElement.value : 1;
      }
      onQuantityElementChange() {
        this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
      }
    }
    customElements.define('product-main', ProductMain);
  
    class ComponentProductCardAtc extends ProductMain {
      constructor() {
        super()
        this.swatches = this.querySelector('.swatch-group')
        this.addEventListener('variantChange', this.onVariantChange.bind(this));
        this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
        this.currentImageUrl = '';
        this.imageObserver = null;
        this.clickOutHandler = null;
        
        this.optionsButton = this.querySelector('.atc-options');
        if (this.optionsButton) {
          this.optionsButton.addEventListener('click', this.openOptions.bind(this));
        }
  
        var self = this;
        if (self.classList.contains('colors-out')) { 
          setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
            self.colorSwatches = self.querySelector('product-swatch.color-swatches');
            if (self.colorSwatches) {
              self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin',self.colorSwatches);
            }
          }, 10);
        }
      }
  
      openOptions() {
        var container = this.querySelector('.atc-options-wrapper form');
        this.querySelector('.atc-options-wrapper').classList.add('open');
        $s.trapFocus(container);
        var self = this;
        if (!this.clickOutHandler) {
          this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
        }
        this.clickOutHandler = function(evt) {
          if(container !== evt.target && !container.contains(evt.target)) {
            self.closeOptions.bind(self)();
          }
        }
        document.addEventListener('mousedown', this.clickOutHandler);
      }
      closeOptions() {
        this.querySelector('.atc-options-wrapper').classList.remove('open');
        document.removeEventListener('mousedown', this.clickOutHandler);
        $s.removeTrapFocus();
      }
  
      onVariantChange(event) {
        var image = event.detail.variant.featured_image;
        var img = this.querySelector('.img.main');
        var width = Math.ceil(img.width / 100) * 100;
        if (img.classList.contains('lazyload')) {
          img.setAttribute('data-srcset', image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage);
        } else {
          this.currentImageUrl = image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage;
          if (!this.imageObserver) {
            if (!img.classList.contains('lazyloaded')) {
              this.imageObserver = new MutationObserver(mutations => {
                if (img.classList.contains('lazyloaded')) {
                  this.imageObserver.disconnect();
                  this.imageObserver = null;
                  img.setAttribute('srcset', this.currentImageUrl);
                }
              });
              var config = { attributes: true, attributeFilter: ['class']};
              this.imageObserver.observe(img, config);
            } else {
              img.setAttribute('srcset', this.currentImageUrl);
            }
          }
        }
  
      }
    }
    customElements.define('product-card-atc', ComponentProductCardAtc); 
    
  // Update metafields based on Variant selected for Stock Status + Product Details fields
  document.addEventListener("DOMContentLoaded", () => {
    const variantIdInput = document.querySelector("input[data-variant-id-status]");
    const stockStatusInput = document.getElementById("stock-status");
  
    function updateMetafieldsDisplay(variantId) {
      const allMetafieldElements = document.querySelectorAll("[data-variant-id-status]");
      const selectedMetafieldElements = document.querySelectorAll(`[data-variant-id-status="${variantId}"]`);
  
      allMetafieldElements.forEach(element => {
        element.style.display = "none";
      });
  
      selectedMetafieldElements.forEach(element => {
        element.style.display = "block";
  
        if (stockStatusInput) {
          const metafieldValue = element.getAttribute('data-stock-status');
  
          // Update the hidden input value if the metafieldValue exists
          if (metafieldValue) {
            stockStatusInput.value = metafieldValue.trim();
          }
        }
      });
    }
  
    function handleVariantIdInputChange() {
      const variantId = variantIdInput.value;
      updateMetafieldsDisplay(variantId);
      console.log("variantId", variantId);
    }
  
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === "attributes" && mutation.attributeName === "value") {
          handleVariantIdInputChange();
        }
      });
    });
    if (variantIdInput) {
      observer.observe(variantIdInput, { attributes: true });
      handleVariantIdInputChange();
    }
  });
  
  
  
  
  
  } 
    
  
  if(!customElements.get('collapse-social-share')) {
    class CollapseSocialShare extends HTMLElement {
      constructor() {
        super();
        this.collapsed = true;
        this.elShare = document.querySelector(`.${this.dataset.shareElementClass}`);
        this.elTrigger = this.querySelector('.btn-share')
        if (this.elShare && this.elTrigger) {
          this.initBindings()
        }
      }
      initBindings() {
        this.elTrigger.addEventListener('click', e => {
          e.preventDefault();
          if (this.collapsed) {
            this.elShare.classList.remove('hide')
            this.elTrigger.style.fontWeight = '600'
            this.collapsed = false
          } else {
            this.elShare.classList.add('hide')
            this.elTrigger.style.fontWeight = '400'
            this.collapsed = true
          }
        })
      }
    }
    customElements.define('collapse-social-share', CollapseSocialShare);
  }
  
  if(!customElements.get('product-buttons')) {
    function protection_price_range(variant_price) {
      try {
        var is_bridal_product = window.product.is_bridal, protection_variant_list;
        if (is_bridal_product) {
          protection_variant_list = window.protection.protection_product_lifetime;
        } else {
          protection_variant_list = window.protection.protection_product_3y;
          document.getElementById('product-protection-option-1').value = "1 Year";
          document.getElementById('product-protection-option-2').value = "2 Year";
          document.getElementById('product-protection-option-3').value = "3 Year";
          document.querySelector(".protection-plan-option-1 .update-year").innerHTML = "1 Year";
          document.querySelector(".protection-plan-option-2 .update-year").innerHTML = "2 Year";
          document.querySelector(".protection-plan-option-3 .update-year").innerHTML = "3 Year";
        }
        // return false;
        var price_range = "";
        for (var obj in protection_variant_list) {
          var lower_price_range = obj.split(" / ")[1].split("-")[0] * 100;
          var higher_price_range = obj.split(" / ")[1].split("-")[1] * 100;
          if (
            variant_price >= lower_price_range &&
            variant_price <= higher_price_range
          ) {
            price_range = obj.split(" / ")[1];
            break;
          }
        }
        if (!price_range.length) {
          document.querySelector(".protection-plan-wrapper").style.display = "none";
          document.querySelectorAll(".product-clarity-commitment .protection-plan-wrapper input").forEach((input) => (input.checked = false));
          return false;
        }
        // console.log(protection_variant_list[`3 / ${price_range}`]);
        if (is_bridal_product) {
          return [
            ...protection_variant_list[`3 / ${price_range}`],
            ...protection_variant_list[`5 / ${price_range}`],
            ...protection_variant_list[`10 / ${price_range}`],
          ];
        } else {
          return [
            ...protection_variant_list[`1 / ${price_range}`],
            ...protection_variant_list[`2 / ${price_range}`],
            ...protection_variant_list[`3 / ${price_range}`],
          ];
        }
      } catch (e) {
        console.log(e);
      }
    }
    function variant_update_protection_price(variantPrice){
      // console.log(variantPrice);
      try {
        var data = protection_price_range(variantPrice);
        console.log(data);
        if(!data){
          return false;
        }
        var [
            price_option1,
            variant_option1,
            price_option2,
            variant_option2,
            price_option3,
            variant_option3,
          ] = data;
        // console.log("price_option1",price_option1);
        // console.log(price_option1,
        //   variant_option1,
        //   price_option2,
        //   variant_option2,
        //   price_option3,
        //   variant_option3);
        let productPlan1 = document.querySelector('.protection-plan-option-1');
        let productPlan2 = document.querySelector('.protection-plan-option-2');
        let productPlan3 = document.querySelector('.protection-plan-option-3');
        productPlan1.setAttribute("data-protection-id", variant_option1);
        productPlan2.setAttribute("data-protection-id", variant_option2);
        productPlan3.setAttribute("data-protection-id", variant_option3);
        productPlan1.querySelector('.update-price').textContent = $s.formatMoney(price_option1).replace('.00', '');
        productPlan2.querySelector('.update-price').textContent = $s.formatMoney(price_option2).replace('.00', '');
        productPlan3.querySelector('.update-price').textContent = $s.formatMoney(price_option3).replace('.00', '');
      } catch (e) {
        console.log(e);
      }
    }
    function variant_update_klarna_placement(variantPrice){
      try{
        console.log("variantPrice", variantPrice);
        const klarnaPlacement = document.getElementById('klarna-placement-product');
        klarnaPlacement.setAttribute('data-purchase-amount', variantPrice);
      } catch (e) {
        console.log('error in variant_update_klarna_placement', e);
      } 
    }
    class ProductButtons extends HTMLElement {
        constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.dynamicButtons = this.querySelector('.shopify-payment-button');
        this.bisTrigger = this.querySelector('.btn.BIS_trigger');
        this.selectionRequired = this.mainElement.dataset.requireSelection=='true';
        this.bisTrigger = this.querySelector('.btn.BIS_trigger');
  
        this.mainElement.addEventListener('variantChange', (e)=>{
          var requiredBtn = this.querySelector('.btn.selection-required');
          variant_update_protection_price(event.detail.variant.price);
          variant_update_klarna_placement(event.detail.variant.price);
          if(document.querySelectorAll('product-custom-option[data-required="true"]').length >= 1){
           
          }else{
            console.log("this.required()", e.detail.variant);
            if (this.required()) {
              requiredBtn.style.display = '';
              requiredBtn.innerHTML = this.requiredMessage;
            } else if(e.detail.variant && e.detail.variant.available) {
              if (this.dynamicButtons) {
                this.dynamicButtons.classList.remove('hide');
              }
              this.querySelector('.btn.add').style.display = '';
              this.querySelector('.sold-out-message').style.display = 'none';
              document.querySelector('#btn-add-to-cart-2 .btn').textContent = 'ADD TO BAG';
              this.bisTrigger && (this.bisTrigger.style.display = 'none');
              if (requiredBtn) requiredBtn.style.display = 'none';
            } else {
              if (this.dynamicButtons) {
                this.dynamicButtons.classList.add('hide');
              }
              this.querySelector('.btn.add').style.display = 'none';
              this.querySelector('.sold-out-message').style.display = '';
              document.querySelector('#btn-add-to-cart-2 .btn').textContent = 'This item is currently SOLD OUT.';
              this.bisTrigger.style.display = 'block';
              if (requiredBtn) requiredBtn.style.display = 'none';
            }
          }
  
        });
        // this.bisTrigger && this.bisTrigger.addEventListener('click', this.bisTriggerEvent.bind(this));
      }
  
      // bisTriggerEvent() {
      //   document.querySelector('.bis-button.BIS_trigger').trigger('click');
      // }
      required() {
        if (this.selectionRequired) {
          var options = this.mainElement.querySelectorAll('product-swatch, product-dropdown');
          var required = false;
          this.requiredMessage = '';
          for (var i=0; i<options.length; i++) {
            if (options[i].required()) {
              var label = options[i].dataset.label;
              var firstLetter = label[0].toLowerCase();
              var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a';
              this.requiredMessage = 'Add to Bag';
              break;
            }
          }
          if (!this.requiredMessage) {
            this.selectionRequired = false;
          }
        }
        return this.selectionRequired;
      }
    }
    customElements.define('product-buttons', ProductButtons);
  }
  
  if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
    class ProductMedia extends HTMLElement {
      constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.itemsWrapper = this.querySelector(':scope > div');
        this.desktopStyle = this.dataset.desktop;
        this.mobileStyle = this.dataset.mobile;
        this.slider = false;
  
        this.lastVariant = null;
  
        this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
        window.addEventListener('mediaChange', this.onMediaChange.bind(this))
        setTimeout(()=>{
          this.onMediaChange();
          
        }, 10);
  
        
      }
  
      filterMediaType(type) {
        this.mainElement.productData.media.forEach((media)=>{
          var show = media.media_type === type;
          if(show) {
            this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
          } else {
            this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
          }
        });
        /*
        if (type === "image") {
          this.filterMedia(this.lastVariant, type)
        } else {
          this.filterMedia(this.lastVariant, type)
          if(this.slider) {
            this.slider.refresh();
          }
        }*/
    
        this.filterMedia(this.lastVariant, type)
        if(this.slider) {
            this.slider.refresh();
          }
      }
  
      findFilterMediaType(variant) {
        this.lastVariant = variant;
        let visibleTypes = this.mainElement.productData.media.map((media) => {
          var show = true;
          if (media.alt && media.alt != "") {
            var mediaAlt = media.alt.indexOf('|') > -1 ? media.alt.split('|')[1] : media.alt;
            var filter = mediaAlt.split(';');
            filter.forEach((f) => {
              if (show) {
                var key = f.split(':')[0];
                var values = f.split(':')[1];
                var optionIndex = this.mainElement.productData.options.findIndex(x => x == key);
                if (optionIndex >= 0) {
                  var found = false;
                  values.split(',').forEach((value) => {
                    if (variant.options[optionIndex] == value) {
                      found = true;
                    }
                  });
                  show = found;
                }
              }
            });
          }
         return ({ show: show, media: media });
        });
  
        let mediaImageMatches = [];
        let mediaVideoMatches = [];
        visibleTypes.forEach((i) => {
          if (i?.show === true && i?.media?.media_type === 'image') {
            mediaImageMatches.push(i);
          }
          if (i?.show === true && i?.media.media_type === 'video') {
            mediaVideoMatches.push(i);
          }
        })
        //check if type is set to video, if video switch to image, if image proceed 
        if (mediaVideoMatches.length > 0){
          if(mediaImageMatches.length > 0){
            return {types: ['video', 'image'], has_video: true, has_image: true}; 
          }else {
            return {types: ['video'], has_video: true, has_image: false}; 
          }
        }
        else if(mediaVideoMatches.length <= 0 ){
          if(mediaImageMatches.length > 0){
            return {types: ['image'], has_video: false, has_image: true}; 
          }else {
            return {types: ['image'], has_video: false, has_image: false}; 
          }
        } 
    }
  
      filterMedia(variant, type = "video") {
        this.lastVariant = variant;
        let visibleTypes = this.mainElement.productData.media.map((media) => {
          var show = true;
          if (media.alt && media.alt != "") {
            var mediaAlt = media.alt.indexOf('|') > -1 ? media.alt.split('|')[1] : media.alt;
            var filter = mediaAlt.split(';');
            filter.forEach((f) => {
              if (show) {
                var key = f.split(':')[0];
                var values = f.split(':')[1];
                var optionIndex = this.mainElement.productData.options.findIndex(x => x == key);
                if (optionIndex >= 0) {
                  var found = false;
                  values.split(',').forEach((value) => {
                    if (variant.options[optionIndex] == value) {
                      found = true;
                    }
                  });
                  show = found;
                }
              }
            });
          }
         return ({ show: show, media: media });
        });
  
        let mediaImageMatches = [];
        let mediaVideoMatches = [];
        visibleTypes.forEach((i) => {
          if (i?.show === true && i?.media?.media_type === 'image') {
            mediaImageMatches.push(i);
          }
          if (i?.show === true && i?.media.media_type === 'video') {
            mediaVideoMatches.push(i);
          }
        })
  
        //check if type is set to video, if video switch to image, if image proceed 
        let diamondSizeSliderWrapper = document.querySelector('.diamond-size-slider-wrapper') || null;
        if(diamondSizeSliderWrapper){
          diamondSizeSliderWrapper.style.display = 'none';
        }
        console.log("type", type);
        if (type === 'video' && mediaVideoMatches.length > 0){
          visibleTypes.forEach((i)=>{
            if (i.show && i.media.media_type === type) {
              this.querySelector('[data-media-id="' + i.media.id + '"]').style.display = 'block';
            } else {
              this.querySelector('[data-media-id="' + i.media.id + '"]').style.display = 'none';
            }
          })
        }
        else if(type === 'video' && mediaVideoMatches.length <= 0 ){
          type = 'image';
          visibleTypes.forEach((i)=>{
            if (i.show && i.media.media_type === type) {
              this.querySelector('[data-media-id="' + i.media.id + '"]').style.display = 'block';
            } else {
              this.querySelector('[data-media-id="' + i.media.id + '"]').style.display = 'none';
            }
          })
        } 
        else if(type === 'image'){
          visibleTypes.forEach((i)=>{
            if (i.show && i.media.media_type === type) {
              this.querySelector('[data-media-id="' + i.media.id + '"]').style.display = 'block';
            } else {
              this.querySelector('[data-media-id="' + i.media.id + '"]').style.display = 'none';
            }
          })
        }else if(type === 'Diamond Size'){
          if(diamondSizeSliderWrapper){
            diamondSizeSliderWrapper.style.display = 'block';
          }
        }
  
      if(this.slider) {
        this.slider.refresh();
      }
    }
  
      onVariantChange() {
      }
  
      onMediaChange() {
      }
  
      initSlider() {
      }
  
      removeSlider() {
        if(this.slider) {
          this.slider.destroy();
          this.slider = false;
          this.classList.remove('keen');
          this.itemsWrapper.classList.remove('keen-slider');
          this.querySelectorAll(':scope > div').forEach((slide)=>{
            slide.classList.remove('keen-slider-slide')
          });
        }
      }
  
      showItem(mediaId, animate=true) {
        if(this.slider) {
          var index = Array.from(this.itemsWrapper.querySelectorAll(':scope > div'))
            .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
          if(animate) {
            this.slider.moveToSlideRelative(index, true);
          } else {
            this.slider.moveToSlideRelative(index, true, 0);
          }
        }
      }
    }
    
    class ProductGallery extends ProductMedia {
      constructor() {
        super();
  
        if(!this.closest('.tingle-modal')) {
          this.querySelectorAll('[data-file]').forEach((media)=>{
            media.addEventListener('click', (e)=>{
              var visibleItems = [];
              this.querySelectorAll('[data-media-id]').forEach((obj)=>{
                if($s.isVisible(obj)) {
                  let element  = obj.querySelector('[data-file], video, iframe');
                  if(element) {
                    visibleItems.push(element);
                  }
                }
              });
              $s.photoSwipe(visibleItems, media);
            });
          });
          //3D Models
          this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
            model.addEventListener('click', (e)=>{
              $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
            });
          });
        }
      }
  
      onVariantChange(e) {
        var variant = e.detail.variant;
        var animate = e.detail.animate;
        //When a user changes a variant they will now be able to operate in the media gallery of their chosing if available. 
        // i need to test what happens when VIDEO is previously selected but doesn't exist for one of the items
        const allControlButtons = document.querySelectorAll('.gallery-control-btn');
        const prevSelectedGalleryBtn = allControlButtons && Array.from(allControlButtons).find((elBtn) => elBtn.classList.contains('btn-active'))
        const prevSelectedType = prevSelectedGalleryBtn && prevSelectedGalleryBtn.dataset.mode;
        
        //here is where i would likely have to do companisons on the gallery to determine type
        if(this.mainElement.productData.media && variant && prevSelectedType) {
          this.filterMedia(variant, prevSelectedType); 
          if(variant.featured_media) {
            this.showItem(variant.featured_media.id, animate)
          }
        }
      }
  
      onMediaChange() {
        if($s.media.isSmall || this.desktopStyle=='carousel') {
          this.initSlider();
        } else {
          this.removeSlider();
        }
      }
  
      initSlider() {
        if(!this.slider) {
          this.classList.add('keen');
          this.itemsWrapper.classList.add('keen-slider');
          this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
            slide.classList.add('keen-slider-slide')
          });
  
          var breakpoints = {};
          if(this.mobileStyle=='dots') {
            breakpoints['(max-width: '+window.breakpoints.small+')'] = {
              dots: this.querySelector('.keen-dots')
            }
          }
          
          this.slider = new KeenSlider(this.itemsWrapper, {
            mode: "snap",
            loop: true,
            wheel: false,
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next'),
            dots: this.querySelector('.keen-dots'),
            slideChanged: (keen)=>{
              $s.pauseAllMedia(this);
              this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
            },
            breakpoints
          });
        }
      }
    }
    customElements.define('product-gallery', ProductGallery);
  
    class ProductThumbs extends ProductMedia {
      constructor() {
        super();
        this.mainGallery = this.mainElement.querySelector('product-gallery');
  
        this.querySelectorAll('[data-media-id]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            this.mainGallery.showItem(media.dataset.mediaId);
          });
        });
  
        this.mainGallery.addEventListener('slideChanged', (e)=>{
          var currentSlide = e.detail.currentSlide();
          if(currentSlide) {
            var currentMediaId = currentSlide.dataset.mediaId;
            var currentSlideElement = this.querySelector('.current-slide');
            if(currentSlideElement) {
              currentSlideElement.classList.remove('current-slide');
            }
            this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          }
        });
      }
  
      onVariantChange(e) {
        var variant = e.detail.variant;
        if(this.mainElement.productData.media && variant) {
          this.filterMedia(variant)
        }
      }
  
      onMediaChange() {
        if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && this.desktopStyle=='carousel' )) {
          this.style.display = 'block';
          this.initSlider();
        } else {
          this.style.display = 'none';
          this.removeSlider();
        }
      }
  
      initSlider() {
        if(!this.slider) {
          this.classList.add('keen');
          this.itemsWrapper.classList.add('keen-slider');
          this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
            slide.classList.add('keen-slider-slide')
          });
          var breakpoints = {};
          breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
            slidesPerView: 4,
            spacing: 10
          }
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            slidesPerView: 5,
            spacing: 10
          }
          this.slider = new KeenSlider(this.itemsWrapper, {
            mode: "snap",
            loop: true,
            centered: true,
            slidesPerView: 7,
            spacing: 15,
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next'),
            breakpoints
          });
        }
      }
    }
    customElements.define('product-thumbs', ProductThumbs);
  }
  
  if(!customElements.get('product-price')) {
    class ProductPrice extends HTMLElement {
        constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.dealElement = this.querySelector('.deal');
        this.retailElement = this.querySelector('.retail');
        this.nowElement = this.querySelector('.price-now');
        this.pricingContainerElement = this.querySelector('.pricing-container'); 
        this.affirmContainerElement = document.querySelector('.affirm-wrapper'); 
        this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
  
        this.listenEvents = ['variantChange','sellingPlanChange'];
        if (this.multiplyQuantity)
          this.listenEvents.splice(1, 0, 'quantityChange');
  
        this.listenEvents.forEach((event)=>{
          this.mainElement.addEventListener(event, (e)=>{
            var data = e.detail.variant || e.detail.sellingPlan;
            if(!data) {
              data = this.mainElement.getCurrentVariant();
            }
              if(data && data.available !==false) {
              var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
                  this.dealElement.innerHTML = `${$s.formatMoney(data.price * quantity).replace('.00', '')}`;
  
              if(data.compare_at_price > data.price) {
                this.retailElement.classList.remove('hide');
                this.retailElement.innerHTML = `${$s.formatMoney(data.compare_at_price * quantity).replace('.00', '')}`;
                this.nowElement.classList.remove('hide');
                this.nowElement.innerHTML = `Save 10%`;
                this.pricingContainerElement.style.flexDirection = 'column';
              } else {
                this.retailElement.classList.add('hide');
                this.retailElement.innerHTML = '';
                if(this.nowElement) {
                  this.nowElement.classList.add('hide');
                  this.nowElement.innerHTML = '';
                }
                if(this.pricingContainerElement) {
                  this.pricingContainerElement.style.flexDirection = 'row';
                }
              }
              } else {//if no data or sold out - clear the inner html for the element
                  this.dealElement.innerHTML = '';
              this.retailElement.innerHTML = '';
              this.nowElement.innerHTML = '';
              this.pricingContainerElement.innerHTML = '';
              this.affirmContainerElement.classList.add('hide-affirm');
              this.pricingContainerElement.style.flexDirection = 'row';
              }
          });
        });
      }
    }
    customElements.define('product-price', ProductPrice);
  }
  
  if(!customElements.get('product-stock-info')) {
    class ProductStockInfo extends HTMLElement {
        constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.stockElement = this.querySelector('.in-stock-message');
        this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
        this.listenEvents = ['variantChange','sellingPlanChange'];
        if (this.multiplyQuantity)
          this.listenEvents.splice(1, 0, 'quantityChange');
  
        this.listenEvents.forEach((event)=>{
          this.mainElement.addEventListener(event, (e)=>{
            var data = e.detail.variant || e.detail.sellingPlan;
            if(!data) {
              data = this.mainElement.getCurrentVariant();
            }
              if(data) {
            if(data.available !== false) { //if not sold out 
                this.stockElement.classList.remove('hide'); //show
              } else {// if sold out 
               this.stockElement.classList.add('hide'); //hide
              }
              } else {
                      this.stockElement.classList.add('hide'); //hide
              }
          });
        });
      }
    }
    customElements.define('product-stock-info', ProductStockInfo);
  }
  
  if (!customElements.get('product-gallery-controls')) {
    class ProductGalleryControls extends HTMLElement {
      constructor () {
        super();
  
        this.mainElement = this.closest('.product-main-element');
        this.elProductGallery = this.mainElement.querySelector('product-gallery');
        this.elBtnControls = this.querySelectorAll('.gallery-control-btn');
        
        this.initEvents();
      }
  
      clearButtons () {
        Array.from(this.elBtnControls).forEach(elBtn => elBtn.classList.remove('btn-active'))
      }
  
      initEvents () {
        this.initVideosAutoplay();
        this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this));
        Array.from(this.elBtnControls).forEach(elBtn => {
          elBtn.addEventListener('click', event => {
            this.clearButtons();
            event.currentTarget.classList.add('btn-active');
            this.elProductGallery.filterMediaType(event.currentTarget.dataset.mode);
          });
        });
      }
  
      onVariantChange(e) {
        var variant = e.detail.variant;
        //find the current selected media type
        const prevSelectedGalleryBtn = Array.from(this.elBtnControls).find((elBtn) => elBtn.classList.contains('btn-active'))
        const prevSelectedType = prevSelectedGalleryBtn.dataset.mode;
        //Check to update active button based on the availability of the video type
        let mediaTypes = this.elProductGallery.findFilterMediaType(variant); 
        const imageButton = document.querySelector('.btn-images'); 
        const videoButton = document.querySelector('.btn-videos'); 
        try{
          if (mediaTypes.has_image && mediaTypes.has_video){
            imageButton.classList.add('flex')
            videoButton.classList.add('flex')
          }else if (!mediaTypes.has_image && mediaTypes.has_video){
            imageButton.classList.remove('flex')
            imageButton.style.display = "none"; 
            videoButton.classList.add('flex')
          }else if (mediaTypes.has_image && !mediaTypes.has_video){
            imageButton.classList.add('flex')
            videoButton.classList.remove('flex')
            videoButton.style.display = "none"; 
          }else if (!mediaTypes.has_image && !mediaTypes.has_video){
            imageButton.classList.remove('flex')
            imageButton.style.display = "none"; 
            videoButton.classList.remove('flex')
            videoButton.style.display = "none"; 
          }
        }catch(e){
          console.log(e);
        }
        this.clearButtons();
      //determine which type to display: if no match display the default provided from filter function
       const filterForMatch = mediaTypes.types.find(m => m === prevSelectedType); 
       const mediaType = filterForMatch != null ? filterForMatch : mediaTypes.types[0]; 
       Array.from(this.elBtnControls).find(elBtn => elBtn.dataset.mode === mediaType).classList.add('btn-active'); 
      }
  
      initVideosAutoplay () {
        this.elProductGallery.addEventListener('slideChanged', event => {
          var elCurrentSlide = event.detail.currentSlide();
          var elSlideVideo = elCurrentSlide?.querySelector('video') || null;
          if (elSlideVideo) {
            this.stopAllVideos();
            elSlideVideo.play();
          }
        })
      }
  
      stopAllVideos () {
        var allVideos = this.elProductGallery.querySelectorAll('video');
        Array.from(allVideos).forEach(elVideo => elVideo.pause());
      }
    }
    customElements.define('product-gallery-controls', ProductGalleryControls);
  }
  
  
  if(!customElements.get('product-variants')) {
    class ProductVariants extends HTMLElement {
      constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.variantInput = this.querySelector('[data-variant-id]');
  
        this.bindOptions();
        setTimeout(()=>{
          this.variantChange(this.getCurrentVariant(), false);
        }, 10);
      }
  
      getCurrentVariant() {
        return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
      }
  
      setVariant(variant) {
        if(typeof variant !== 'object') {
          variant = this.mainElement.productData.variants.find(x=>x.id==variant);
        }
        if(variant) {
          this.refreshOptions(-1, variant);
          this.variantChange(variant);
        }
      }
  
      variantChange(variant, animate=true) {
        if(variant) {
          this.variantInput.value = variant.id;
        } else {
          this.variantInput.value = '';
        }
        this.previousVariant = variant;
        this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
        this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));
      }
  
      calculateNewVariant(optionChanged, value) {
        var newVariants = this.mainElement.productData.variants;
        
        //workaround for adding selection placeholders
        this.previousVariant = this.previousVariant || this.getCurrentVariant();
  
        this.mainElement.productData.options.forEach((option, index)=>{
          if(optionChanged==index) {
            newVariants = newVariants.filter(x=>x.options[index]==value);
          } else {
            var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
            if(tmpNewVariants.length==0) {
              tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
            }
            newVariants = tmpNewVariants;
          }
        });
        return newVariants[0];
      }
  
      bindOptions() {
        this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
          element.addEventListener('change', (e)=>{
            let optionIdx = element.dataset.option-1;
            let variant = this.calculateNewVariant(optionIdx, e.target.value);
            this.refreshOptions(element.dataset.option-1, variant);
            this.variantChange(variant);
          });
        });
      }
  
      getOptionValues(currentVariant) {
        var options = [];
        this.mainElement.productData.options.forEach((option, index)=>{
          if(index==0) {
            var optionValues = this.mainElement.productData.variants.map((variant)=>{
              var stockQuantity = document.querySelector(`[data-product-variant-id="${variant.id}"]`).dataset.stockQuantity;
              return {
                value: variant.options[index], 
                available: variant.available,
                stockQuantity: stockQuantity
              }
            });
          }
          if(index==1) {
            var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{
              var stockQuantity = document.querySelector(`[data-product-variant-id="${variant.id}"]`).dataset.stockQuantity;
              return {
                value: variant.options[index],
                available: variant.available,
                stockQuantity: stockQuantity
              }
            });
          }
          if(index==2) {
            var optionValues = this.mainElement.productData.variants.filter(
              x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
            ).map((variant)=>{
              var stockQuantity = document.querySelector(`[data-product-variant-id="${variant.id}"]`).dataset.stockQuantity; 
              return {
                value: variant.options[index],
                available: variant.available,
                stockQuantity: stockQuantity
              }
            });
          }
          var optionValuesUnique = [];
          optionValues.forEach((option, key)=>{
            if(!optionValuesUnique.find(x=>x.value==option.value)) {
              if(option.available) {
                optionValuesUnique.push(option);
              } else {
                if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                  optionValuesUnique.push(option);
                }
              }
            }
          });
          options.push(optionValuesUnique);
        });
        return options;
      }
  
      refreshOptions(updateOptionIndex=-1, currentVariant) {
        var optionValues = this.getOptionValues(currentVariant);
        this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
          let index = element.dataset.option - 1;
          if(index > updateOptionIndex) {
            element.buildOptions(optionValues[index], currentVariant.options[index]);
          }
          var optionValueElement = element.querySelector('.option-value');
          if(optionValueElement) {
            optionValueElement.innerHTML = currentVariant.options[index];
          }
        });
      }
    }
    customElements.define('product-variants', ProductVariants);
  }
  
  if(!customElements.get('product-swatch')) {
    class ProductSwatch extends HTMLElement {
        constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.variantsElement = this.mainElement.querySelector('product-variants');
        this.optionNumber = this.dataset.option;
        this.label = this.dataset.label;
        this.required(this.mainElement.dataset.requireSelection=='true');
        this.info = (window.optionsInfo && window.optionsInfo.length > 0) 
          ? window.optionsInfo.find(v => v.option_name == this.label)
          : false;
  
        this.buildOptionSelector();
      }
  
      required(newValue) {
        if (typeof(newValue)!='undefined') {
          this.setAttribute('data-required', newValue ? 'true' : 'false')
        }
        return this.getAttribute('data-required')=='true'
      }
  
      displayOptionsChecker(options) {
        var activeOptions = options.filter((v) => v.available === true);
        var showOptions = activeOptions.length > 0 ? true : false; 
        return showOptions; 
      }
  
      buildOptionSelector() {
        var currentVariant = this.mainElement.getCurrentVariant();
        var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
        var defaultValue = currentVariant.options[this.optionNumber-1];
          var optionElement = document.createElement('div');
        
        var viableOptions = this.displayOptionsChecker(optionValues); 
        
        if( viableOptions === true ){
          var html = `
          <div class="option-name flex align-items-center justify-content-between">${this.label}</div>
          <div class="swatch-group flex flex-wrap"></div>
          `;
    
          this.innerHTML = html;
    
          if(this.info){
            var popupButton = document.createElement('button');
            popupButton.setAttribute('type','button');
            popupButton.classList.add('info-btn');
            popupButton.addEventListener('click', this.openInfo.bind(this))
            this.querySelector('.option-name').appendChild(popupButton);
          }
    
          this.buildOptions(optionValues, defaultValue);
        }
      }
  
      buildOptions(options, defaultValue) {
          var html = '';
            options.forEach((option, index)=>{
          var optionNameHandle = (this.label.toLocaleLowerCase().indexOf('metal') >= 0) ? 'color' : $s.handleize(this.label);
          var optionValueHandle = $s.handleize(option.value);
          html += `
            <div class="swatch" data-available="${option.available}">
              <input type="radio" id="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}" value="${option.value}" />
                      <label for="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}" class="flex align-items-center small--direction-column">
                <div class="label-inner ${optionNameHandle}-${optionValueHandle}"></div>
                <span>${option.value}</span>
              </label>
            </div>
                `;
            });
            var group = this.querySelector('.swatch-group');
            group.innerHTML = html;
  
            if (this.required()) {
          group.addEventListener('change', ()=>{
            this.required(false);
          }, {once: true})
        } else {
          if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
            group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
          } else {
            group.querySelector('input').checked = true;
          }
        }
      }
  
      openInfo(){
        var html = `
          <div class="container">
            <h3 class="title">${this.info.title}</h3>
            <div class="text">${this.info.text}</div>
            ${(this.info.image1 ? `<img class="lazyload" data-srcset="${this.info.image1}" alt="" />` : ``)}
          </div>
        `
        $s.openModal(html, 'default-popup');
      }
    }
    customElements.define('product-swatch', ProductSwatch);
  }
  
  if(!customElements.get('product-dropdown')) {
    class ProductDropdown extends HTMLElement {
        constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.variantsElement = this.mainElement.querySelector('product-variants');
        this.optionNumber = this.dataset.option;
        this.label = this.dataset.label;
        this.info = (window.optionsInfo && window.optionsInfo.length > 0) 
          ? window.optionsInfo.find(v => v.option_name == this.label)
          : false;
        this.required(this.mainElement.dataset.requireSelection=='true');
  
        this.buildOptionSelector();
  
        if (this.required()) {
          var select = this.querySelector('select');
          select.addEventListener('change', ()=>{
            this.required(false);
            select.querySelector('[disabled]').remove();
            select.removeAttribute('required');
          }, {once: true})
        }
      }
  
      buildOptionSelector() {
        var currentVariant = this.mainElement.getCurrentVariant();
        var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
        var defaultValue = currentVariant.options[this.optionNumber-1];
  
        var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber;
        var optionElement = document.createElement('div');
        var html = `
          <label class="option-name flex align-items-center justify-content-between" for="${optionId}">${this.label}</label>
          <select id="${optionId}" required></select>
        `;
        this.innerHTML = html;
  
        if(this.info){
          var popupButton = document.createElement('button');
          popupButton.setAttribute('type','button');
          popupButton.classList.add('info-btn');
          popupButton.addEventListener('click', this.openInfo.bind(this))
          this.querySelector('.option-name').appendChild(popupButton);
        }
  
        this.buildOptions(optionValues, defaultValue);
      }
  
      required(newValue) {
        if (typeof(newValue)!='undefined') {
          this.setAttribute('data-required', newValue ? 'true' : 'false')
        }
        return this.getAttribute('data-required')=='true'
      }
  
      buildOptions(options, defaultValue) {
          var html = '';
        if (this.required()) {
                html += `<option value="${defaultValue || ''}" disabled selected>Select your ${this.label}</option>`;
        }
            options.forEach((option, index)=>{
                let soldOut = (!option.available ? ' - Sold Out' : '');
          let inStock = (option.stockQuantity > 0 ? ' - In Stock' : '');
                html += `<option value="${option.value.replace('"','&#34')}">${option.value}${soldOut}${inStock}</option>`;
            });
            var select = this.querySelector('select');
            select.innerHTML = html;
  
            if(defaultValue) {
              var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
              if(newValueIndex>=0) {
                  select.selectedIndex = newValueIndex;
              }
            }
      }
  
      openInfo(){
        var html = `
          <div class="container">
            <h3 class="title">${this.info.title}</h3>
            <div class="text">${this.info.text}</div>
          </div>
        `
        $s.openModal(html, 'default-popup');
      }
    }
    customElements.define('product-dropdown', ProductDropdown);
  }
  if(!customElements.get('product-custom-option')) {
    class ProductCustomOption extends HTMLElement {
        constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.variantsElement = this.mainElement.querySelector('product-variants');
        this.optionType = this.dataset.optionType;
        this.optionJson = JSON.parse(this.dataset.optionJson);
        this.optionsSuboptionsLength = 2;
        this.info = (window.optionsInfo && window.optionsInfo.length > 0) 
          ? window.optionsInfo.find(v => v.option_name == this.optionJson.title)
          : false;
  
        this.buildOption();
        
        this.querySelectorAll('select').forEach((obj)=>{
          obj.addEventListener('change', this.onChangeSelectHandler.bind(this),{once: true})
        })
        
        setTimeout(()=>{
          document.querySelectorAll('product-custom-option[data-required="true"]').forEach(function(e) {
            if(document.querySelectorAll('product-custom-option[data-required="true"]').length >= 1){
              document.querySelector('.btn.selection-required').style.display = "block";
              document.querySelector('.btn.add').style.display = "none";
            }
            if(e.querySelector('select')){e.querySelector('select').addEventListener('change', function(x){
             e.setAttribute("data-required","false")
               if(document.querySelectorAll('product-custom-option[data-required="true"]').length == 0){
                 document.querySelector('.btn.selection-required').style.display = "none";
                 document.querySelector('.btn.add').style.display = "block";
               }          })}
            if(e.querySelector('input')){e.querySelector('input').addEventListener('change', function(j){
              if(e.querySelector('input').value != ""){
                e.setAttribute("data-required","false")
                  if(document.querySelectorAll('product-custom-option[data-required="true"]').length == 0){
                    document.querySelector('.btn.selection-required').style.display = "none";
                    document.querySelector('.btn.add').style.display = "block";
                  }            }else{
                e.setAttribute("data-required","true")
              }
            })}
          })},200)
  
  
      }
  
  
  
      onChangeSelectHandler(e){
        var select = e.target;
        select.removeAttribute('required');
      }
  
      buildSelects(){
        var html = '';
        for (let i = 1; i <= this.optionsSuboptionsLength; i++) {
          if(this.optionJson[`suboption_${i}_title`] != ''){
            html += `
            <select name="properties[${this.optionJson[`suboption_${i}_title`]}]" required>
              <option value="" disabled selected>${this.optionJson[`suboption_${i}_title`]}</option>
              ${this.optionJson[`suboption_${i}_values`].split(',').map(v => `<option value="${v}">${v}</option>`).join('')}
            </select>`;
          }
        }
        return html;
      }
  
      buildSelect(){
        var html = '';
          if(this.optionJson[`suboption_title`] != ''){
            html += `
            <select name="properties[${this.optionJson[`suboption_title`]}]" required>
              <option value="" disabled selected>${this.optionJson[`suboption_title`]}</option>
              ${this.optionJson[`suboption_values`].split(',').map(v => `<option value="${v}">${v}</option>`).join('')}
            </select>`;
          }
        return html;
      }
  
      buildOption() {
        var html = `
          <label class="option-name flex align-items-center justify-content-between" for="">${this.optionJson.title}</label>
        `;
  
        if(this.optionType == 'custom_option_selector'){
          html += `<div class="flex options-wrapper">${this.buildSelects()}</div>`;
          this.innerHTML = html;
        }
        if(this.optionType == 'custom_ring_selector'){
          html += `<div class="flex options-wrapper">${this.buildSelect()}</div>`;
          this.innerHTML = html;
        }
        if(this.optionType == 'custom_option_text' ){
          html = `
          <label class="option-name engraving-class flex align-items-center justify-content-between" for="">${this.optionJson.title}</label>
          <div class="engraving-class engraving-input">
            <div><input ${(this.optionJson.max_char) ? `maxlength="${this.optionJson.max_char}"` : ``} type="text" name="properties[${this.optionJson[`title`]}]" placeholder="${this.optionJson[`placeholder`]}" id="input-engraving" /></div>
            <div class="flex justify-content-between align-items-center engraving-characters">
              ${(this.optionJson.max_char) ? `<div class="current-characters">0 characters</div>` : ``}
              ${(this.optionJson.max_char) ? `<div class="">Max. ${this.optionJson.max_char} characters</div>` : ``}
            </div>
          </div>`;
  
          this.innerHTML = html;
  
          if(this.optionJson.max_char) {
            this.querySelector('.engraving-input').addEventListener('keyup', this.keyUpHandler.bind(this));
          }
  
          // prevent emojis and any special char.
          this.querySelector('.engraving-input').addEventListener( "input", event => {
            event.target.value = event.target.value.replace( /[^a-zA-Z0-9 ]/gm, '');
          }, false);
          
          this.querySelector('.engraving-input').addEventListener( "paste", event => {
            event.target.value = event.target.value.replace( /[^a-zA-Z0-9 ]/gm, '');
          }, false);
        }
  
        if(this.optionType == 'custom_cutout_text' ){
          html = `
          <label class="option-name cutout-class cutout-input-hide flex align-items-center justify-content-between" for="">${this.optionJson.title}</label>
          <div class="cutout-input cutout-class cutout-input-hide">
            <div><input ${(this.optionJson.max_char) ? `maxlength="${this.optionJson.max_char}"` : ``} type="text" name="properties[${this.optionJson[`title`]}]" placeholder="${this.optionJson[`placeholder`]}" /></div>
            <div class="flex justify-content-between align-items-center engraving-characters">
              ${(this.optionJson.max_char) ? `<div class="current-characters">0 characters</div>` : ``}
              ${(this.optionJson.max_char) ? `<div class="">Max. ${this.optionJson.max_char} characters</div>` : ``}
            </div>
          </div>`;
  
          this.innerHTML = html;
  
          if(this.optionJson.max_char) {
            this.querySelector('.cutout-input').addEventListener('keyup', this.keyUpHandler.bind(this));
          }
  
          // prevent emojis and any special char.
          this.querySelector('.cutout-input').addEventListener( "input", event => {
            event.target.value = event.target.value.replace( /[^a-zA-Z0-9 ]/gm, '');
          }, false);
          
          this.querySelector('.cutout-input').addEventListener( "paste", event => {
            event.target.value = event.target.value.replace( /[^a-zA-Z0-9 ]/gm, '');
          }, false);
  
          var radios = document.getElementsByClassName("engraving-check");
          for(var i = 0, max = radios.length; i < max; i++) {
              radios[i].onclick = function() {
                  if(this.value == "option-engraving"){
                    document.querySelector(".cutout-input input").value= "";
                    document.querySelector(".cutout-input .current-characters").innerHTML= "0 characters";
                      document.querySelectorAll(".engraving-class").forEach(function(el) {
                        el.classList.remove("engraving-input-hide");
                      })
                          
                      document.querySelectorAll(".cutout-class").forEach(function(el) {
                        el.classList.add("cutout-input-hide");
                      })
                  }
                  if(this.value == "option-cutout"){
                    document.querySelector(".engraving-input input").value= ""
                    document.querySelector(".engraving-input .current-characters").innerHTML= "0 characters";
                        document.querySelectorAll(".engraving-class").forEach(function(el) {
                        el.classList.add("engraving-input-hide");
                      })
                          
                      document.querySelectorAll(".cutout-class").forEach(function(el) {
                        el.classList.remove("cutout-input-hide");
                      })
                  }
              }
          }
        }
  
        if(this.info){
          var popupButton = document.createElement('button');
          popupButton.setAttribute('type','button');
          popupButton.classList.add('info-btn');
          popupButton.addEventListener('click', this.openInfo.bind(this))
          this.querySelector('.option-name').appendChild(popupButton);
        }
      }
  
      keyUpHandler(e){
        this.querySelector('.current-characters').innerHTML = `${e.target.value.length} character${(e.target.value.length != 1) ? `s`:``}`;
      }
  
      openInfo(){
        var html = `
          <div class="container">
            <h3 class="title">${this.info.title}</h3>
            <div class="text">${this.info.text}</div>
            ${(this.info.image1 ? `<img class="lazyload" data-srcset="${this.info.image1}" alt="" />` : ``)}
            ${(this.info.image2 ? `<img class="lazyload" data-srcset="${this.info.image2}" alt="" />` : ``)}
          </div>
        `
        $s.openModal(html, 'default-popup');
      }
    }
    customElements.define('product-custom-option', ProductCustomOption);
  }
  
  if(!customElements.get('product-model')) {
    class ProductModel extends HTMLElement {
      constructor() {
        super();
        this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');
  
        window.Shopify.loadFeatures([{
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXr.bind(this)
        }]);
      }
  
      setupShopifyXr() {
        if(!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', ()=>{
            this.setupShopifyXr();
          });
        } else {
          window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
          setTimeout(()=>{
            window.ShopifyXR.setupXRElements();
          }, 100);
        }
      }
    }
    customElements.define('product-model', ProductModel);
  }
  /*
  REF: FEATURE PICKUP AVAILABILITY
  if(!customElements.get('pickup-availability')) {
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.mainElement = this.closest('product-main');
  
        this.mainElement.addEventListener('variantChange', (e)=>{
          if(e.detail.variant && e.detail.variant.available) {
            this.fetchAvailability(e.detail.variant.id);
          } else {
            this.innerHTML = '';
          }
        });
      }
  
      fetchAvailability(variantId) {
        let rootUrl = routes.root;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;
  
        $s.get({
          url: variantSectionUrl,
          success: (data)=>{
            this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
            this.bindEvents();
          },
          error: ()=>{
            this.innerHTML = '';
          }
        });
      }
  
      bindEvents() {
        let button = this.querySelector('button');
        if(button) {
          button.addEventListener('click', ()=>{
            $s.openModal(this.querySelector('.pickup-availability-info'), 'test');
          });
        }
      }
    }
    customElements.define('pickup-availability', PickupAvailability);
  }
  */
  
  
  if(!customElements.get('product-details-redirector')) {
    class ProductDetailsRedirector extends HTMLElement {
      constructor() {
        super();
        this.btnEl = this.querySelector('.btn-product-details');
        this.redirectToEl = document.querySelector(`.${this.dataset.redirectTo}`)
        this.initBindings();
      }
      initBindings () {
        if(this.btnEl && this.redirectToEl) {
          this.btnEl.addEventListener('click', event => {
            event.preventDefault();
            var newTop = this.redirectToEl.parentNode.offsetTop - document.getElementById('header').offsetHeight - 40;
            window.scrollTo({
              top: newTop,
              left: 0,
              behavior: 'smooth'
            });
          })
        }
      }
    }
    customElements.define('product-details-redirector', ProductDetailsRedirector);
  }
  
  